"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../commonFunctions");
var PluginTemplates_1 = require("../../../../PluginTemplates");
var ValuableItemModal = /** @class */ (function (_super) {
    __extends(ValuableItemModal, _super);
    function ValuableItemModal(props) {
        var _this = _super.call(this, props) || this;
        _this.totalValueOfItems = _this.props.totalValueOfItems;
        _this.renderButtonWithInfoMsg = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "font-weight-extra-light text-center p-3 banner banner-info" }, _this.renderButtonInfoMsg()),
                _this.renderButton()));
        };
        _this.renderButton = function () {
            if (_this.props.existingItem) {
                return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next btn-update ".concat(!_this.state.isFormValid && "btn-disabled"), onClick: function (e) { return _this.state.isFormValid ? _this.handleAdd() : e.preventDefault; } }, "Update"));
            }
            else if (_this.state.isItemInsuredAutomatically) {
                return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next w-100", onClick: _this.props.hide }, "Ok, I understand"));
            }
            else if (_this.props.item.premium === 0 && !_this.calculationRequired()) {
                return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next w-100 ".concat(!_this.state.isFormValid && "btn-disabled"), onClick: function (e) { return _this.state.isFormValid ? _this.handleAdd() : e.preventDefault; } }, "Add at no extra cost"));
            }
            else if (_this.props.item.premium > 0 && !_this.calculationRequired()) {
                return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next w-100 ".concat(!_this.state.isFormValid && "btn-disabled"), onClick: function (e) { return _this.state.isFormValid ? _this.handleAdd() : e.preventDefault; } },
                    "Add for ",
                    (0, commonFunctions_1.getAmountToDisplay)(_this.props.item.premium),
                    " / month"));
            }
            else if (_this.calculationRequired()) {
                return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next w-100 ".concat((!_this.state.isFormValid || _this.state.isInsuredValueLargerSeventeenPercents) && "btn-disabled"), onClick: function (e) { return _this.state.isFormValid ? _this.handleCheck() : e.preventDefault; } }, "Check cost"));
            }
        };
        _this.renderCategorySelect = function () {
            return (React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "item-categories" },
                    React.createElement("b", { className: "font-weight-semi-bold" }, "What kind of item do you want to cover?")),
                React.createElement("div", { className: "input-group w-md-75" },
                    React.createElement.apply(React, __spreadArray(["select", { id: "item-categories", className: "form-control", onChange: _this.handleCategoryChange, value: _this.state.item.valuableItemType }, React.createElement("option", { value: "" }, "Please select")], Object.keys(services_1.ValuableItemTypeEnum).map(function (key, index) {
                        return React.createElement("option", { key: index, value: services_1.ValuableItemTypeEnum[key] }, PluginTemplates_1.PluginTemplates.getItemWordings(services_1.ProductNameEnum.RENTERS, services_1.ValuableItemTypeEnum[key]).title);
                    }), false)))));
        };
        _this.renderDescriptionInput = function () {
            return (React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "description" },
                    "Description ",
                    React.createElement("span", { className: "font-weight-extra-light" }, PluginTemplates_1.PluginTemplates.getItemWordings(services_1.ProductNameEnum.RENTERS, _this.props.item.valuableItemType).description)),
                React.createElement("div", { className: "input-group w-100" },
                    React.createElement("input", { type: "text", id: "description", className: "form-control", value: _this.state.item.description || "", maxLength: 100, onChange: _this.handleDescriptionChange }))));
        };
        _this.renderValueInput = function () {
            return (React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "value" },
                    "How much would it cost to replace this item brand new?",
                    React.createElement("br", null),
                    React.createElement("span", { className: "font-weight-extra-light" }, "(This is maximum we can pay if you make a claim)")),
                React.createElement("div", { className: "input-group d-flex align-items-center" },
                    React.createElement("span", { className: "fs-22 font-weight-bold" }, "\u00A3"),
                    React.createElement("input", { type: "text", id: "value", className: "form-control w-25 mx-2", value: _this.state.item.value || "", onChange: _this.handleValueChange }),
                    React.createElement("span", null, " (maximum \u00A35,000)")),
                React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0" },
                    !_this.state.isValueValid && "Enter value between £1 and £5000",
                    _this.state.isValueValid && _this.state.isTotalValueExceeded && "You’re about to exceed your £20000 specified items limit",
                    _this.state.isValueValid && !_this.state.isTotalValueExceeded && _this.state.isInsuredValueExceeded && "You\u2019re about to exceed your \u00A3".concat(_this.props.insuredValue, " specified items limit"))));
        };
        _this.renderCoverLocationRadio = function () {
            return (React.createElement("div", { className: "form-group mt-4" },
                React.createElement("label", null,
                    React.createElement("span", { className: "font-weight-extra-light" }, "Do you want to"),
                    " cover this item outside the home?"),
                React.createElement("div", { className: "input-group width-450", role: "group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { className: "custom-control-input", type: "radio", name: "specified-items-radio", id: "location-outside", value: services_1.ValuableItemCoverLocation.ANYWHERE, checked: _this.state.item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE, onChange: _this.handleLocationChange }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "location-outside" }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { className: "custom-control-input", type: "radio", name: "specified", id: "location-inside", value: services_1.ValuableItemCoverLocation.HOME, checked: _this.state.item.coverLocation === services_1.ValuableItemCoverLocation.HOME, onChange: _this.handleLocationChange }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "location-inside" }, "No")))));
        };
        _this.renderMobileProtectionAlert = function () {
            return (React.createElement("div", { className: "d-flex align-items-start bg-white-blue rounded p-3 mb-3" },
                React.createElement("img", { className: "d-block mr-3 mt-1", src: "/img/Flow-attention.svg", alt: "warning" }),
                React.createElement("div", null,
                    "Please first ",
                    React.createElement("b", null, "check if you're already protected"),
                    ", e.g. if you have an iPhone verify if you signed up for AppleCare+",
                    React.createElement("div", { className: "text-decoration-underline cursor-pointer text-blue-1", onClick: function () { return _this.setState({ showMobileProtectionAlert: false }); } },
                        React.createElement("b", null, "Ok, thanks")))));
        };
        _this.renderValuableItemsTotalPriceAlert = function () {
            return (React.createElement("div", { className: "d-flex align-items-start bg-white-blue rounded p-3 mb-3" },
                React.createElement("img", { className: "d-block mr-3 mt-1", src: "/img/Flow-attention.svg", alt: "warning" }),
                React.createElement("div", null,
                    "Looks like you've used up most of your contents limit on specified items, you may want to review your total contents limit to ensure you're covered for all of your possessions in the event of a claim.",
                    React.createElement("div", { className: "text-decoration-underline cursor-pointer text-blue-1", onClick: function () { return _this.setState({ isInsuredValueLargerSeventeenPercents: false }); } },
                        React.createElement("b", null, "Ok, I understand")))));
        };
        _this.renderButtonInfoMsg = function () {
            var item = _this.state.item;
            var valueAsNumber = Number(item.value);
            var isValueValid = Boolean(item.value) && Number.isInteger(valueAsNumber) && valueAsNumber !== 0;
            var isCoverLocationValid = Boolean(item.coverLocation);
            if (isValueValid && isCoverLocationValid) {
                if (_this.state.isItemInsuredAutomatically) {
                    return React.createElement(React.Fragment, null,
                        "Good news \u2013 ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "as it\u2019s worth less than \u00A32,000"),
                        " we\u2019ll cover this item inside the home as standard, so there\u2019s no need to specify it");
                }
                else {
                    return React.createElement(React.Fragment, null,
                        "Heads up - You will be able to ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, "add images & receipts of the item later in your account"));
                }
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.handleCategoryChange = function (event) {
            var item = _this.state.item;
            item.valuableItemType = event.target.value;
            _this.setState({ item: item }, function () { return _this.validateForm(); });
        };
        _this.handleDescriptionChange = function (event) {
            var item = _this.state.item;
            item.description = event.target.value;
            _this.setState({ item: item }, function () { return _this.validateForm(); });
        };
        _this.handleValueChange = function (event) {
            if (event.target.value.match("^[0-9]*$")) {
                var item = _this.state.item;
                item.value = event.target.value;
                _this.setState({ item: item }, function () {
                    _this.validateValue(true);
                    _this.validateForm();
                });
            }
        };
        _this.handleLocationChange = function (event) {
            var item = _this.state.item;
            item.coverLocation = event.target.value;
            _this.setState({ item: item }, function () { return _this.validateForm(); });
        };
        _this.validateForm = function () {
            var item = _this.state.item;
            var isCategoryValid = Boolean(item.valuableItemType);
            var isDescriptionValid = Boolean(item.description);
            var isLocationValid = Boolean(item.coverLocation);
            var isLocationHome = item.coverLocation === services_1.ValuableItemCoverLocation.HOME;
            var isValueValid = _this.validateValue(false);
            var isItemInsuredAutomatically = Boolean(item.value && item.value >= 1 && item.value <= 2000) && isLocationHome;
            _this.setState({ isItemInsuredAutomatically: isItemInsuredAutomatically });
            if (isCategoryValid && isDescriptionValid && isValueValid && isLocationValid && !isItemInsuredAutomatically) {
                _this.setState({ isFormValid: true });
                return true;
            }
            else {
                _this.setState({ isFormValid: false });
                return false;
            }
        };
        _this.validateValue = function (updateFieldValidation) {
            var isValueValid = Boolean(_this.state.item.value && _this.state.item.value >= 1 && _this.state.item.value <= 5000);
            var isTotalValueExceeded = Boolean(_this.state.item.value && (_this.totalValueOfItems + Number(_this.state.item.value)) > 20000);
            var isInsuredValueExceeded = Boolean(_this.state.item.value && (_this.totalValueOfItems + Number(_this.state.item.value)) > _this.props.insuredValue);
            var isInsuredValueLargerSeventeenPercents = Boolean(_this.state.item.value && (_this.totalValueOfItems + Number(_this.state.item.value)) > _this.props.insuredValue * 0.7);
            updateFieldValidation && _this.setState({ isValueValid: isValueValid, isTotalValueExceeded: isTotalValueExceeded, isInsuredValueExceeded: isInsuredValueExceeded, isInsuredValueLargerSeventeenPercents: isInsuredValueLargerSeventeenPercents });
            return isValueValid && !isTotalValueExceeded && !isInsuredValueExceeded;
        };
        _this.handleCheck = function () {
            if (_this.validateForm()) {
                _this.setState({ item: __assign(__assign({}, _this.state.item), { valuableItemId: _this.props.item.valuableItemId }) }, function () { return _this.props.onCheck(_this.state.item); });
            }
        };
        _this.handleAdd = function () {
            if (_this.validateForm()) {
                _this.props.onConfirm(_this.state.item);
            }
        };
        _this.state = {
            item: __assign({}, _this.props.item),
            isValueValid: true,
            isTotalValueExceeded: false,
            isInsuredValueExceeded: false,
            isInsuredValueLargerSeventeenPercents: false,
            isFormValid: false,
            showMobileProtectionAlert: true,
            isItemInsuredAutomatically: false
        };
        return _this;
    }
    ValuableItemModal.prototype.render = function () {
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 cover-amount-modal", isOpen: this.props.show, toggle: this.props.hide },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.hide, close: React.createElement("button", { className: "btn-close", onClick: this.props.hide }) },
                React.createElement("div", { className: "mb-4 text-blue-2 font-weight-medium" }, this.props.title)),
            React.createElement(reactstrap_1.ModalBody, { className: "py-0 fs-16 font-weight-extra-light" },
                this.renderCategorySelect(),
                this.state.item.valuableItemType === services_1.ValuableItemTypeEnum.MOBILE && this.state.showMobileProtectionAlert && this.renderMobileProtectionAlert(),
                this.renderDescriptionInput(),
                this.renderValueInput(),
                this.state.isInsuredValueLargerSeventeenPercents && this.renderValuableItemsTotalPriceAlert(),
                this.renderCoverLocationRadio(),
                React.createElement("div", { className: "mobile-kb-buttons" }, this.renderButtonWithInfoMsg())),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-block desktop-buttons" }, this.renderButtonWithInfoMsg())));
    };
    ValuableItemModal.prototype.calculationRequired = function () {
        if (this.props.item.value == null || this.state.item.value == null) {
            return true;
        }
        else {
            var isValueChanged = this.props.item.value.toString() !== this.state.item.value.toString();
            var isLocationChanged = this.props.item.coverLocation !== this.state.item.coverLocation;
            return isValueChanged || isLocationChanged;
        }
    };
    return ValuableItemModal;
}(React.Component));
exports.default = ValuableItemModal;
//# sourceMappingURL=ValuableItemModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/coveredAnywhereWidget/ValuableItemModal.js
// module id = 2558
// module chunks = 0